/* eslint-disable jsx-a11y/anchor-is-valid */

import { ColumnInfo, Language, DetailsList, FilterType, FilterValue } from '@eta/components';
import {
    DetailsListLayoutMode,
    SelectionMode,
  
} from '@fluentui/react';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { NumberOfShimmerLines, UIHelpers } from '../../../helpers/UIHelpers';
import {
   
    TaxpayerActivityDto
} from '../../../Services/ClientProxy/clientProxy';
import './ActivityCodeGrid.scss';

interface ActivityCodeGridProps {
    currentLanguage: Language | undefined;
    items: TaxpayerActivityDto[] | undefined | null;
}
export const ActivityCodeGrid: FC<ActivityCodeGridProps> = (props: ActivityCodeGridProps) => {
    const { currentLanguage, items } = props;

    const { t } = useTranslation(['ActivityCode','common']);
    const [columns, setColumns] = useState<ColumnInfo[]>();
  
    const [itemsState, setItemsState] = useState<TaxpayerActivityDto[] | undefined | null>([]);


    useEffect(() => {
        const filterDuplicateCode = items?.filter((item, index, obj) =>
        index === obj.findIndex((activity => (
            activity.activityTypeId === item.activityTypeId
        ))
        ))?.sort(() => {return -1;});
        setItemsState(filterDuplicateCode);
    }, [items]);

  const CheckIFActive = (toDate?: Date): boolean => {
      return (toDate ?? new Date()) >= new Date();
  };

    useEffect(() => {
        const gridColumns = [
            {
                key: 'ActivityCode',
                name: t('activityCode'),
                fieldName: 'activityCode',
                minWidth: 100,
                maxWidth: 120,
                isResizable: true,
                isSorted: true,
                isSortedDescending: true,
                allowSorting: true,
                isRowHeader: true,
                filterOption: {
                    placeholder: '',
                    type: FilterType.Text,
                    fieldNames: [
                        {
                            fieldName: 'activityTypeCode',
                            displayName: t('activityCode'),
                        }
                    ],
                    comparator: (value: string, filterValue: FilterValue) => {                     
                        if (value?.includes(filterValue?.toString().trim() || '') || value?.trim() === filterValue?.toString().trim()) {
                            return true;
                        }
                        return (false);
                    }
                },
                
                onRender: (item: TaxpayerActivityDto) => {
                    return (
                        <span>
                           {item.activityTypeCode}
                        </span>
                    );
                },
            },

            {
                key: 'Description',
                name: t('description'),
                fieldName: 'Description',
                minWidth: 100,
                maxWidth: 700,
                isResizable: true,
                isSorted: false,
                isSortedDescending: false,
                isRowHeader: true,
                filterOption: {
                    placeholder: '',
                    type: FilterType.Text,
                    fieldNames: [
                        {
                            fieldName: currentLanguage?.lang === 'en' ? 'activityTypeNamePrimaryLang':'activityTypeNameSecondaryLang',
                            displayName: t('description'),
                        }
                    ],
                    comparator: (value: string, filterValue: FilterValue) => {
                        if (value?.includes(filterValue?.toString().trim() || '') || value?.trim() === filterValue?.toString().trim()) {
                            return true;
                        }
                        return (false);
                    }
                },

                onRender: (item: TaxpayerActivityDto) => {
                    return (
                        <span>
                          {currentLanguage?.lang === 'en' ? item?.activityTypeNamePrimaryLang:item?.activityTypeNameSecondaryLang}
                        </span>
                    );
                },
            },
            {
                key: 'IsPrimary',
                name: t('isPrimary'),
                fieldName: 'IsPrimary',
                minWidth: 100,
                maxWidth: 100,
                isResizable: true,
                isSorted: false,
                isSortedDescending: false,
                isRowHeader: true,
                filterOption: {
                    placeholder: '',
                    type: FilterType.Enum,
                    fieldNames: [
                        {
                            fieldName: 'isPrimeActivity',
                            displayName: t('isPrimary'),
                        }
                    ],
                    options: [
                        { key: 'true', text: t('yes') },
                        { key: 'false', text: t('no') },
                    ],
                    comparator: (value: boolean, filterValue: FilterValue) => {
                        if (value && filterValue === 'true') {
                            return (true);
                        }
                        if (!value && filterValue === 'false') {
                            return true;
                        }
                        return false;
                    },
                },
                onRender: (item: TaxpayerActivityDto) => {
                    return (
                      
                            <span className="inActive">
                                {item.isPrimeActivity
                                    ? t('yes')
                                    : t('no')}
                            </span>
                        
                    );
                },
            },
            {
                key: 'Status',
                name: t('status'),
                fieldName: 'status',
                minWidth: 100,
                maxWidth: 170,
                isResizable: false,
                isSorted: false,
                isSortedDescending: false,
                isRowHeader: true,
                filterOption: {
                    placeholder: '',
                    type: FilterType.Enum,
                    fieldNames: [
                        {
                            fieldName: 'toDate',
                            displayName: t('status'),
                        }
                    ],
                    options: [
                        { key: 'active', text: t('active') },
                        { key: 'inactive', text: t('inactive') },
                    ],
                    comparator: (value: Date , filterValue: FilterValue) => {
                        const isActive =CheckIFActive(value);
                        if (isActive && filterValue === 'active') {
                            return (true);
                        }
                        if (!isActive && filterValue === 'inactive') {
                            return true;
                        }
                        return false;
                    },
                },
                onRender: ({fromDate, toDate}: TaxpayerActivityDto) => {
                    return (
                        <span
                            className={
                                CheckIFActive(toDate) ? 'green' : 'inActive'
                            }
                        >
                            {`${
                                CheckIFActive(toDate)
                                    ? t('active')
                                    : t('inactive')
                            } (${UIHelpers.getLocalizedDateTime(
                                'Date',
                                fromDate,
                                currentLanguage?.lang
                            )} - ${UIHelpers.getLocalizedDateTime(
                                'Date',
                                toDate,
                                currentLanguage?.lang
                            )})`}
                        </span>
                    );
                },
            }
           
        ];
        setColumns(gridColumns);
    }, [ t,currentLanguage]);

    return (
        <div>
            <DetailsList
                className="grid ActivityCodeGrid"
                columns={columns ?? []}
                items={itemsState??[]}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.justified}
                labels={{
                    resultPerPage: t('common:nbItemPerPage'),
                    totalRecord: t('common:totalRecord'),
                }}
                shimmerLines={NumberOfShimmerLines}
                enableShimmer={!itemsState}
                paginationSetting={{
                    nbItemPerPage: 10,
                    nbPageShown: 5,
                }}
                noItemsPlaceholder={<span>{t('common:NoRecords')}</span>}
            />
        </div>
    );
};
